import { useContext } from 'react'
import { LanguageContext, ILanguageContext } from '@dataplace.ai/features/contexts/LanguageContext'

function useLanguageContext(): ILanguageContext {
  const context = useContext(LanguageContext)

  if (!context) throw new Error('useLanguageContext must be used within a LanguageContextProvider')

  return context
}

export default useLanguageContext
